import React from 'react'
import Layout from '../components/includes/Layout'
import ProjectsMain from '../components/projects/ProjectsMain';
const Projects = () => {
  return (

     <Layout>
      <ProjectsMain/>
     </Layout>

  )
}

export default Projects